"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _core = require("@emotion/core");

var _d = require("d3");

var _lodash = require("lodash");

var _shortid = _interopRequireDefault(require("shortid"));

var _window = _interopRequireDefault(require("global/window"));

var _civicFormat = _interopRequireDefault(require("../utils/civicFormat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 2.5px 0 5px 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  position: absolute;\n  padding: 0 10px 0 5px;\n  background: rgba(0, 0, 0, 0.75);\n  color: #fff;\n  max-width: 275px;\n  z-index: 9;\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var tooltip = (0, _core.css)(_templateObject());
var tooltipText = (0, _core.css)(_templateObject2());

var MapTooltip = function MapTooltip(props) {
  var tooltipData = props.tooltipData;
  var x = tooltipData.x;
  var y = tooltipData.y;
  var xPositionOffset = 25;
  var xPosition = x < (0, _lodash.get)(_window["default"], "innerWidth", 1000) * 0.66 ? x + xPositionOffset : x - xPositionOffset * 3;
  var yPositionOffset = 50;
  var yPostition = y < 375 ? y + yPositionOffset : y - yPositionOffset * 2.75;
  var percentageFormat = (0, _d.format)(".1%");

  var sandboxPercentFormat = function sandboxPercentFormat(p) {
    return p < 1 && p > 0 ? percentageFormat(p) : "".concat(p.toFixed(1), "%");
  };

  var sandboxDecimalFormat = (0, _d.format)(".2n");

  var sandboxMoneyFormat = function sandboxMoneyFormat(d) {
    return "$".concat(_civicFormat["default"].numericShort(d));
  };

  var tooltipContent = tooltipData.content.map(function (t) {
    var formatType = t.format;
    var formattedValue = t.value && formatType === "percentage" ? sandboxPercentFormat(t.value) : t.value && formatType === "dollars" ? sandboxMoneyFormat(t.value) : t.value && formatType === "decimal" ? sandboxDecimalFormat(t.value) : t.value && formatType && _civicFormat["default"][formatType] ? _civicFormat["default"][formatType](t.value) : t.value ? t.value : "No Data Available";
    return (0, _core.jsx)("div", {
      css: tooltipText,
      key: _shortid["default"].generate()
    }, "".concat(t.label || t.name, ": ").concat(formattedValue));
  });
  return (0, _core.jsx)("div", {
    css: tooltip,
    style: {
      left: xPosition,
      top: yPostition
    }
  }, tooltipContent);
};

MapTooltip.propTypes = {
  tooltipData: (0, _propTypes.shape)({
    x: _propTypes.number,
    y: _propTypes.number,
    content: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      label: _propTypes.string,
      value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
    }))
  })
};
var _default = MapTooltip;
exports["default"] = _default;